type Props = {
  isSvg: boolean;
  colorStyle: number;
  styles: { readonly [key: string]: string };
};

export default function handleColorStyle({ isSvg, colorStyle, styles }: Props) {
  if (!isSvg) {
    switch (colorStyle) {
      case 1:
        return styles._bg_degrade;
      case 2:
        return styles._bg_lighter_blue;
      case 3:
        return styles._bg_light_blue;
      case 4:
        return styles._bg_medium_light_blue;
      case 5:
        return styles._bg_blue;
      case 6:
        return styles._bg_dark_blue;
      case 7:
        return styles._bg_pink;
      case 8:
        return styles._bg_white;
    }
  } else {
    switch (colorStyle) {
      case 1:
        return styles._border_degrade;
      case 2:
        return styles._border_lighter_blue;
      case 3:
        return styles._border_light_blue;
      case 4:
        return styles._border_medium_light_blue;
      case 5:
        return styles._border_blue;
      case 6:
        return styles._border_dark_blue;
      case 7:
        return styles.border_grey;
      case 8:
        return styles._border_pink;
      case 9:
        return styles._border_white;
    }
  }
}
